function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
var FullScreen = function () {
    function FullScreen(player) {
        var _this = this;
        _classCallCheck(this, FullScreen);
        this.player = player;
        this.lastScrollPosition = {
            left: 0,
            top: 0
        };
        this.singleVideo = !!(this.player.options.video.length > 1) ? 1 : 0;
        this.player.events.on('webfullscreen', function () {
            _this.player.resize();
        });
        this.player.events.on('webfullscreen_cancel', function () {
            _this.player.resize();
            utils.setScrollPosition(_this.lastScrollPosition);
        });
        this.scrollToVolume = function (event) {
            var e = event || window.event;
            e.preventDefault();
            utils.throttle(function () {
                var percentage;
                if (e.deltaY < 0) {
                    percentage = _this.player.video.volume + 0.05;
                    _this.player.volume(percentage, false);
                } else {
                    percentage = _this.player.video.volume - 0.05;
                    _this.player.volume(percentage, false);
                }
            }, 200)();
        };
        var fullscreenchange = function fullscreenchange() {
            _this.player.resize();
            if (_this.isFullScreen('browser')) {
                _this.player.events.trigger('fullscreen');
            } else {
                utils.setScrollPosition(_this.lastScrollPosition);
                _this.player.events.trigger('fullscreen_cancel');
            }
        };
        var docfullscreenchange = function docfullscreenchange() {
            var fullEle = document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            if (fullEle && fullEle !== _this.player.template.videoWrap) {
                return;
            }
            _this.player.resize();
            if (fullEle) {
                _this.player.events.trigger('fullscreen');
            } else {
                utils.setScrollPosition(_this.lastScrollPosition);
                _this.player.events.trigger('fullscreen_cancel');
            }
        };
        if (/Firefox/.test(navigator.userAgent)) {
            document.addEventListener('mozfullscreenchange', docfullscreenchange);
            document.addEventListener('fullscreenchange', docfullscreenchange);
        } else {
            this.player.template.videoWrap.addEventListener('fullscreenchange', fullscreenchange);
            this.player.template.videoWrap.addEventListener('webkitfullscreenchange', fullscreenchange);
            document.addEventListener('msfullscreenchange', docfullscreenchange);
            document.addEventListener('MSFullscreenChange', docfullscreenchange);
        }
    }
    _createClass(FullScreen, [
        {
            key: 'isFullScreen',
            value: function isFullScreen() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                switch (type) {
                case 'browser':
                    return !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
                case 'web':
                    return !!this.player.template.videoWrap.classList.contains('mfunsPlayer-web-fullscreen');
                case 'all':
                    return !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || this.player.template.videoWrap.classList.contains('mfunsPlayer-web-fullscreen'));
                }
            }
        },
        {
            key: 'handleFullscrren',
            value: function handleFullscrren(type) {
                var danmakuRoot = this.player.template.danmakuRoot;
                if (this.player.danmaku && !danmakuRoot.classList.contains('hide') && !this.isFullScreen(type)) {
                    this.player.template.footBarWrap.removeChild(danmakuRoot);
                    this.player.template.controllerWrap.appendChild(danmakuRoot);
                }
                this.player.videoLoaded && this.player.template.videoWrap.addEventListener('wheel', this.scrollToVolume);
            }
        },
        {
            key: 'request',
            value: function request() {
                var _this$player, _this$player$highEner;
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                var anotherType = type === 'browser' ? 'web' : 'browser';
                var anotherTypeOn = this.isFullScreen(anotherType);
                if (!anotherTypeOn) {
                    this.lastScrollPosition = utils.getScrollPosition();
                } else {
                    this.cancel(anotherType);
                }
                switch (type) {
                case 'browser':
                    this.player.template.videoWrap.classList.add('browser-fullscreen');
                    if (this.player.template.videoWrap.requestFullscreen) {
                        this.player.template.videoWrap.requestFullscreen();
                    } else if (this.player.template.videoWrap.mozRequestFullScreen) {
                        this.player.template.videoWrap.mozRequestFullScreen();
                    } else if (this.player.template.videoWrap.webkitRequestFullscreen) {
                        this.player.template.videoWrap.webkitRequestFullscreen();
                    } else if (this.player.template.videoWrap.webkitEnterFullscreen) {
                        this.player.template.videoWrap.webkitEnterFullscreen();
                    } else if (this.player.template.videoWrap.webkitEnterFullScreen) {
                        this.player.template.videoWrap.webkitEnterFullScreen();
                    }
                    this.player.template.fullscreen_tip.innerText = '退出全屏';
                    this.player.template.webfull_btn.classList.add('hide');
                    this.handleFullscrren();
                    this.player.events.trigger('browserfullscreen');
                    break;
                case 'web':
                    this.player.template.videoWrap.classList.add('mfunsPlayer-web-fullscreen');
                    document.body.classList.add('mfunsPlayer-web-fullscreen-fix');
                    this.player.template.webfull_tip.innerText = '退出网页全屏';
                    ((_this$player = this.player) === null || _this$player === void 0 ? void 0 : (_this$player$highEner = _this$player.highEnergy) === null || _this$player$highEner === void 0 ? void 0 : _this$player$highEner.isShow) && this.player.highEnergy.resize();
                    this.handleFullscrren();
                    this.player.events.trigger('webfullscreen');
                    break;
                }
            }
        },
        {
            key: 'handleExitFullscreen',
            value: function handleExitFullscreen(type) {
                var danmakuRoot = this.player.template.danmakuRoot;
                if (this.player.danmaku && !danmakuRoot.classList.contains('hide') && this.isFullScreen(type)) {
                    this.player.template.controllerWrap.removeChild(danmakuRoot);
                    this.player.template.footBarWrap.appendChild(danmakuRoot);
                }
                this.player.template.videoWrap.removeEventListener('wheel', this.scrollToVolume);
            }
        },
        {
            key: 'cancel',
            value: function cancel() {
                var _this$player2, _this$player2$highEne;
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                switch (type) {
                case 'browser':
                    this.player.template.videoWrap.classList.remove('browser-fullscreen');
                    this.handleExitFullscreen('browser');
                    this.player.template.webfull_btn.classList.remove('hide');
                    if (!!this.player.template.tipItem.length) {
                        this.player.template.fullscreen_tip.innerText = '进入全屏';
                    }
                    if (!this.isFullScreen())
                        return;
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.webkitCancelFullscreen) {
                        document.webkitCancelFullscreen();
                    } else if (document.msCancelFullScreen) {
                        document.msCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                    break;
                case 'web':
                    this.handleExitFullscreen('web');
                    this.player.template.videoWrap.classList.remove('mfunsPlayer-web-fullscreen');
                    document.body.classList.remove('mfunsPlayer-web-fullscreen-fix');
                    ((_this$player2 = this.player) === null || _this$player2 === void 0 ? void 0 : (_this$player2$highEne = _this$player2.highEnergy) === null || _this$player2$highEne === void 0 ? void 0 : _this$player2$highEne.isShow) && this.player.highEnergy.resize();
                    this.player.template.webfull_tip.innerText = '网页全屏';
                    this.player.events.trigger('webfullscreen_cancel');
                    break;
                }
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                if (this.isFullScreen(type)) {
                    this.cancel(type);
                } else {
                    this.request(type);
                }
            }
        }
    ]);
    return FullScreen;
}();
export default FullScreen;